import { useGetSellerDetails } from '@/hooks/sellers/useGetSellerDetails';
import { sellerDetailsResponseToSalesConditionsUi } from '@/hooks/sellers/useGetSellerDetails/mapper';
import { useUpdateSellerDetails } from '@/hooks/sellers/useUpdateSellerDetails';
import { WritableDraft } from 'immer';
import { useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
import { useImmer } from 'use-immer';
import { initialState, SalesConditionsUi } from './SalesConditionsUi';

export function useSalesConditionsViewController() {
  const [uiState, setUiState] = useImmer(initialState);
  const sellerId = useParams().sellerId;
  const savedDataUiRef = useRef<SalesConditionsUi>(uiState);
  const getSellerDetailsHook = useGetSellerDetails(sellerId);
  const updateSellerDetails = useUpdateSellerDetails();

  useEffect(() => {
    if (!getSellerDetailsHook.data) return;
    const newState = sellerDetailsResponseToSalesConditionsUi(
      getSellerDetailsHook.data
    );
    savedDataUiRef.current = newState;
    setUiState(newState);
  }, [getSellerDetailsHook.data]);

  const onChangedMinSellAmount = (newMinAmount: string) => {
    const newMinAmountNumber = Number(newMinAmount.trim());
    if (isNaN(newMinAmountNumber)) return;
    setUiState((draft) => {
      draft.minPurchase = `${newMinAmountNumber}`;
      draft.cancelDisabled = false;
      calculateContinueState(draft);
    });
  };

  const calculateContinueState = (draft: WritableDraft<SalesConditionsUi>) => {
    draft.saveDisabled =
      draft.minPurchase.trim() === '' || isNaN(Number(draft.minPurchase));
  };

  const onClickedCancel = () => setUiState(savedDataUiRef.current);

  const onClickedSave = () => {
    if (!sellerId) return;
    updateSellerDetails.mutate({
      sellerId,
      data: { minOrderAmount: uiState.minPurchase },
    });
  };

  return {
    uiState,
    actions: {
      onChangedMinSellAmount,
      onClickedCancel,
      onClickedSave,
    },
  };
}
